import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import { Pagination, PaginationItem, PaginationLink, Col, Input, Row, Label } from "reactstrap";
import { ReactComponent as IconPdf } from "../../../../assets/icons/HorasExtras/PDF.svg"
import { ReactComponent as IconX } from "../../../../assets/icons/HorasExtras/X.svg"
import { ReactComponent as IconCheck } from "../../../../assets/icons/HorasExtras/Chek.svg"
import ModalVistaPreviaDocumentos from "components/Varios/Modals/ModalVistaPreviaDocumentos";
import ModalVistaPreviaDocumento from "components/Varios/Modals/ModalVistaPreviaDocumento";
import ModalRechazo from "components/DirectivoUnidad/AprobacionSolicitudes/ModalRechazoSolicitud";
import ModalCargando from "components/Varios/ModalCargando";
import { GetDocumentVistaPrevia2 } from "helpers/files";
import { AprobarSolicitudesHEDTO, InfGenerDirectivoSolicHEDTO } from "./TypesAprobacionHE";
import { showAlert, showAlertAviso } from "components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import { EnvioSolicitudRechazada, FirmarEnviarSolicitudDirectivoU, ObtenerInformacionGeneral, obtenerValorTotal } from "./ServicesDirectivoSolicitudes";
import { listadoMeses, ObtenerFechaFromIsoFormat } from "functions/DatesFunctions";
import { VistaPreviaSolicitudHETHoUsuario } from "components/Admin/Horas Extras/Revisar Solicitudes Horas Extras/functionsAprobarSolicitudesHE";
import Swal from "sweetalert2";
import { ROL_APROBADOR, ROL_DELEGADO, ROL_DIRECTIVO_UNIDAD } from "Context/SideBarContext";
import { authenticationService } from "services/authentication.service";
import { UserData } from "components/Sidebar/Sidebar_Principal";

type PropsAprobarSolicitudes = {
    informacionContenido: InfGenerDirectivoSolicHEDTO,
    presupuestoDev: number | null,
    actualizacionDatos: () => void,
}

export default function TableAprobarSolicitudes(props: PropsAprobarSolicitudes) {
    const { informacionContenido, actualizacionDatos, presupuestoDev } = props;

    //const [valorAprobadosinTH, setvalorAprobadosinTH] = useState<number | null>(null);
    const [rechazo, setrechazo] = useState<boolean>(false);
    const [infoIndividual, setinfoIndividual] = useState<AprobarSolicitudesHEDTO | null>(null);
    const [loadingAccion, setloadingAccion] = useState<boolean>(false);
    const [urlDocSolicitud, seturlDocSolicitud] = useState<string>("");
    const [urlDocAprobar, seturlDocAprobar] = useState<string>("");

    const [sortColumn, setSortColumn] = useState<string | null>('');
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);
    const [datosOrdenados, setDatosOrdenados] = useState([...informacionContenido.solicitudes]);

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    const info: UserData = authenticationService.currentUserValue;

    async function GenerarVistaPreviaAprobatoriaHE(idSolicitud: number) {
        setloadingAccion(true)
        const respuestaVistaPrevia = await VistaPreviaSolicitudHETHoUsuario(idSolicitud, "DIRECTIVO");

        if (respuestaVistaPrevia.status === 200 && respuestaVistaPrevia.dataResponse && typeof (respuestaVistaPrevia.dataResponse) === "string") {
            seturlDocAprobar(respuestaVistaPrevia.dataResponse)
        }
        else {
            showAlert("No es posible cargar la vista previa del documento", false);
        }
        setloadingAccion(false)
    }

    async function aceptarSolicitud(solicitud: AprobarSolicitudesHEDTO) {
        const fecha = solicitud.fechasolicitud.split("-");
        const fechaMuestra = fecha[2].split("T");
        solicitud.fechasolicitud = `${fecha[0]}-${fecha[1]}-${fechaMuestra[0]}`;

        setinfoIndividual(solicitud);
        GenerarVistaPreviaAprobatoriaHE(solicitud.idsolicitud);

    }

    async function GenerarVistaPreviaSolicitudHE(refArchivo: string) {
        setloadingAccion(true)
        let urlPresentar = await GetDocumentVistaPrevia2(refArchivo);
        if (urlPresentar) {
            seturlDocSolicitud(urlPresentar);
        }
        else {
            seturlDocSolicitud("");
            showAlert("No es posible cargar la vista previa del documento de marcaciones", false);
        }

        setloadingAccion(false)
    }

    async function aceptarTodasSolicitudes(solicitudes: AprobarSolicitudesHEDTO[]) {
        let texto = `<div class="custom-modal-content">
                        <p>¿Está seguro que desea aprobar ${sortedSolicitudes.length} solicitud?</p>
                        </div>`;
        if (sortedSolicitudes.length > 1) {
            texto = `<div class="custom-modal-content">
                        <p>¿Está seguro que desea aprobar ${sortedSolicitudes.length} solicitudes?</p>
                        </div>`;
        }
        const result = await Swal.fire({
            html: texto,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn-cancelar',
                confirmButton: 'btn-aceptar',
                popup: 'custom-popup'
            },
        });

        if (result.isConfirmed) {
            setloadingAccion(true);
            const valorPorAprobar = solicitudes.filter(s => s.estado.trim() === "FS").reduce((acc, row) => acc + (row.tvhorasextras ?? 0), 0);
            const valorAprobado = (presupuestoDev ?? 0) //- (valorAprobadosinTH ?? 0);

            if (valorPorAprobar >= valorAprobado) {
                showAlertAviso("Su presupuesto por devengar no es suficiente para el total de horas extras que desea aprobar");
                setloadingAccion(false);
                return -1;
            }

            const respuestafirma = await FirmarEnviarSolicitudDirectivoU(solicitudes);
            if (respuestafirma.status === 200) {
                showAlert("Las solicitudes han sido firmadas y envíadas a la Dirección de Talento humanH", true);
                await actualizacionDatos();
                setloadingAccion(false);
                return 1;
            }
            else {
                const mensajeDefault = "Ha ocurrido un inconveniente al intentar enviar las solicitud de Horas Extras a la Dirección de Talento Humano."
                showAlert(respuestafirma.errorMessage ?? mensajeDefault, false);
                setloadingAccion(false);
                return -1
            }
            setloadingAccion(false);
        } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
            console.log("Se negó la acción.");
        } else {
            console.log("El modal fue cerrado sin realizar una acción.");
            return;
        }
    }

    async function enviarFirmaDirectivo(solicitudes: AprobarSolicitudesHEDTO) {
        const listaSolicitudes = Array.isArray(solicitudes) ? solicitudes : [solicitudes];
        const valorPorAprobar = (solicitudes.tvhorasextras ?? 0) //- (valorAprobadosinTH ?? 0);

        const valorAprobado = presupuestoDev ?? 0;
        if (valorPorAprobar > valorAprobado && solicitudes.estado.trim() === "FS") {
            showAlertAviso("Esta a punto de exceder el presupuesto disponible para la unidad");
            return;
        }

        const respuestafirma = await FirmarEnviarSolicitudDirectivoU(listaSolicitudes);
        if (respuestafirma.status === 200) {
            showAlert("La solicitud ha sido firmada y envíada a la Dirección de Talento Humano", true);
            await actualizacionDatos();
        }
        else {
            const mensajeDefault = "Ha ocurrido un inconveniente al intentar enviar la solicitud de Horas Extras a la Dirección de Talento Humano."
            showAlert(respuestafirma.errorMessage ?? mensajeDefault, false);
        }
    }

    async function rechazarSolicitud(idSolicitud, observacion) {
        if (idSolicitud) {
            const solicitudRechazada = await EnvioSolicitudRechazada(idSolicitud, observacion);
            if (solicitudRechazada.status == 200) {
                showAlert("La solicitud ha sido negada correctamente", true);
                return 1;
            }
            else {
                const mensajeDefault = "Ha ocurrido un inconveniente al intentar de rechazar su solicitud"
                showAlert(solicitudRechazada.errorMessage ?? mensajeDefault, false);
                return -1;
            }
        }
        return 1;
    }

    // async function valorTotal(idestructura: number) {
    //     const respuestaValor = await obtenerValorTotal(idestructura);
    //     if (respuestaValor.status === 200 && respuestaValor.dataResponse !== undefined) {
    //         setvalorAprobadosinTH(respuestaValor.dataResponse);
    //     }
    //     else {
    //         showAlert(respuestaValor.errorMessage ?? "Ha ocurrido un evento inesperado", false)
    //     }
    // }

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    //ordena de forma alfabetica los nombres de las solicitudes
    useEffect(() => {
        //valorTotal(informacionContenido.informacionAprobador.idEstructuraOrganicaAprobacion);
        handleSort("nombres");
    }, [])

    //reorganiza ascendente o descendente los nombres
    const handleSort = (column) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
    };

    const applySorting = (data) => {
        if (!sortColumn) return data;

        if (data) {
            const sortedData = [...data].sort((a, b) => {
                if (a && b) {
                    var valA = a[sortColumn];
                    var valB = b[sortColumn];

                    if (typeof valA === "string" && typeof valB === "string") {
                        // Sort strings using localeCompare
                        return valA.localeCompare(valB) * (sortDirection === 'asc' ? 1 : -1);
                    } else if (typeof valA === "number" && typeof valB === "number") {
                        // Sort numbers directly
                        return (valA - valB) * (sortDirection === 'asc' ? 1 : -1);
                    }

                    // Handle potential cases where types are mixed or unexpected
                    return 0;
                }

                return 0;


            });
            return sortedData;
        }

    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };
    //filtrado para el buscador
    const filteredSolicitudes = datosOrdenados.filter(solic =>
    (solic.nombres.toLowerCase().includes(searchTerm.toLowerCase()) ||
        solic.regimen.toLowerCase().includes(searchTerm.toLowerCase()) ||
        solic.identificacion.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    //presenta las filas asignadas
    const sortedSolicitudes = applySorting(filteredSolicitudes);
    let currentRows:AprobarSolicitudesHEDTO[] = sortedSolicitudes.slice(indexOfFirstRow, indexOfLastRow);

    //obtiene el numero de paginas segun la cantidad de datos
    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(filteredSolicitudes.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1);
    };

    function horasAMinutos(horas: number | null): number {
        if (!horas) return 0; // Manejar valores nulos o vacíos
        const partes = horas.toString().split(":").map(Number);
        const horasEnMinutos = partes[0] * 60;
        const minutos = partes[1];
        const segundos = partes.length === 3 ? Math.floor(partes[2] / 60) : 0;
        return horasEnMinutos + minutos + segundos;
    }

    function minutosAFormato(minutosTotales: number): string {
        const horas = Math.floor(minutosTotales / 60);
        const minutos = minutosTotales % 60;

        return `${horas}:${String(minutos).padStart(2, "0")}`;
    }

    // const contenidoConfirmacion = useMemo(() => {
    //     return (
    //         <div className='content'>
    //             <div className="titulo_seccion text-center"> ¿Está seguro que desea aprobar {sortedSolicitudes.length} solicitudes?</div>
    //             <br></br>
    //         </div>
    //     )
    // }, [condicion, sortedSolicitudes])

    const contenidoTablaApp = useCallback(() => {
        if (currentRows) {
            return (
                <div className="table-responsive">
                    <Table className="table_planificacion_he table-bordered">
                        <thead className="cabeceras_tabla_servidores_act_he">
                            <tr>
                                <th colSpan={1} align={"center"}> # </th>
                                <th colSpan={1} align={"left"} onClick={() => handleSort("fechasolicitud")}> Fecha</th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("identificacion")}> Cédula </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("nombres")}> Nombres </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("nombreestructuraorganica")}> Unidad </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("regimen")}> Régimen </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("rmu")}> RMU <br /> vigente </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("hesuplementarias")}> Total Horas <br /> Supl. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("heextraordinarias")}> Total Horas <br /> Extraord. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("hetotal")}> Total Horas <br /> (Supl + Extraord) </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("hetotal")}> Horas <br/> Planific. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("vhesuplementarias")}> Valor Horas <br /> Supl. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("vheextraordinarias")}> Valor Horas <br /> Extraord. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("tvhorasextras")}> Valor a Recibir </th>
                                {(info.roles_usuario.includes(ROL_DIRECTIVO_UNIDAD) || info.roles_usuario.includes(ROL_APROBADOR)) &&
                                    <th colSpan={1} align={"center"}> Acciones </th>
                                }
                            </tr>
                        </thead>
                        <tbody className="tbodyAprobacionNominaTH">
                            {currentRows.map((ic, i) => {
                                const globalIndex = indexOfFirstRow + i + 1
                                return (
                                    <React.Fragment key={i}>
                                        <tr className=''>
                                            <td className="centrado"> {globalIndex} </td>
                                            <td className="centrado"> {ObtenerFechaFromIsoFormat(ic.fechasolicitud)} </td>
                                            <td className="centrado"> {ic.identificacion} </td>
                                            <td className="izquierda"> {ic.nombres} </td>
                                            <td className="centrado"> {ic.nombreestructuraorganica} </td>
                                            <td className="centrado DatosNoSolicitudHE"> {ic.regimen} </td>
                                            <td className="centrado DatosNoSolicitudHE"> {ic.rmu.toFixed(2)} </td>
                                            <td className="centrado"> {ic.hesuplementarias} </td>
                                            <td className="centrado"> {ic.heextraordinarias} </td>
                                            <td className="centrado"> {ic.hetotal} </td>
                                            <td className="centrado DatosNoSolicitudHE"> {ic.hetotalplanif} </td>
                                            <td className="centrado"> {ic.vhesuplementarias?.toFixed(2)} </td>
                                            <td className="centrado"> {ic.vheextraordinarias?.toFixed(2)} </td>
                                            <td className="centrado"> {ic.tvhorasextras?.toFixed(2)} </td>
                                            {(info.roles_usuario.includes(ROL_DIRECTIVO_UNIDAD) || info.roles_usuario.includes(ROL_APROBADOR)) && 
                                                <td>
                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                                                        <IconCheck
                                                            className={"icono-blue-2"}
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="Aprobar"
                                                            onClick={() => {
                                                                aceptarSolicitud(ic);
                                                            }}
                                                        />
                                                        <IconX
                                                            className={"icono-blue-2"}
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="Rechazar"
                                                            onClick={() => {
                                                                setrechazo(true);
                                                                setinfoIndividual(ic);
                                                            }}
                                                        />
                                                        {ic.refarchivo !== null &&
                                                            <IconPdf
                                                                className={"icono-blue-2"}
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                title="PDF Marcaciones"
                                                                onClick={() => GenerarVistaPreviaSolicitudHE(ic.refarchivo)}
                                                            />
                                                        }

                                                    </div>
                                                </td>
                                            }
                                        </tr>
                                    </React.Fragment>
                                )
                            })}
                        </tbody>
                        {currentRows.length > 0 &&
                            <tfoot className="tfooterAprobacionNominaTH">
                                {/* <tr>
                                    <td colSpan={5} style={{ border: "none", background: "transparent", padding: 0 }}></td>
                                    <td colSpan={2} style={{ textAlign: "right" }}>Totales {currentRows.length} servidores:</td>
                                    <td className="centrado">
                                        {
                                            minutosAFormato(
                                                currentRows.reduce((acc, row) => acc + horasAMinutos(row.hesuplementarias), 0)
                                            )
                                        }
                                    </td>
                                    <td className="centrado">
                                        {
                                            minutosAFormato(
                                                currentRows.reduce((acc, row) => acc + horasAMinutos(row.heextraordinarias), 0)
                                            )
                                        }
                                    </td>
                                    <td className="centrado">
                                        {
                                            minutosAFormato(
                                                currentRows.reduce((acc, row) => acc + horasAMinutos(row.hetotal), 0)
                                            )
                                        }
                                    </td>
                                    <td className="centrado">{currentRows.reduce((acc, row) => acc + (row.vhesuplementarias ?? 0), 0).toFixed(2)}</td>
                                    <td className="centrado">{currentRows.reduce((acc, row) => acc + (row.vheextraordinarias ?? 0), 0).toFixed(2)}</td>
                                    <td className="centrado">{currentRows.reduce((acc, row) => acc + (row.tvhorasextras ?? 0), 0).toFixed(2)}</td>
                                </tr> */}
                                <tr>
                                    <td colSpan={5} style={{ border: "none", background: "transparent", padding: 0 }}></td>
                                    <td colSpan={2} style={{ textAlign: "right" }}>Total:</td>
                                    <td className="centrado">
                                        {
                                            minutosAFormato(
                                                datosOrdenados.reduce((acc, row) => acc + horasAMinutos(row.hesuplementarias), 0)
                                            )
                                        }
                                    </td>
                                    <td className="centrado">
                                        {
                                            minutosAFormato(
                                                datosOrdenados.reduce((acc, row) => acc + horasAMinutos(row.heextraordinarias), 0)
                                            )
                                        }
                                    </td>
                                    <td className="centrado">
                                        {
                                            minutosAFormato(
                                                datosOrdenados.reduce((acc, row) => acc + horasAMinutos(row.hetotal), 0)
                                            )
                                        }
                                    </td>
                                    <td className="centrado">
                                        {
                                            minutosAFormato(
                                                datosOrdenados.reduce((acc, row) => acc + horasAMinutos(row.hetotalplanif), 0)
                                            )
                                        }
                                    </td>
                                    <td className="centrado">{datosOrdenados.reduce((acc, row) => acc + (row.vhesuplementarias ?? 0), 0).toFixed(2)}</td>
                                    <td className="centrado">{datosOrdenados.reduce((acc, row) => acc + (row.vheextraordinarias ?? 0), 0).toFixed(2)}</td>
                                    <td className="centrado">{datosOrdenados.reduce((acc, row) => acc + (row.tvhorasextras ?? 0), 0).toFixed(2)}</td>
                                </tr>
                            </tfoot>
                        }
                    </Table>
                </div>
            )
        }
    }, [currentRows])

    const contenidoModalRechazo = useMemo(() => {
        if (infoIndividual) {
            return (
                <React.Fragment>
                    <div className="table-responsive">
                        <Table className="table_planificacion_he table table-bordered">
                            <thead className="cabeceras_tabla_servidores_act_he" style={{ fontSize: "0.7rem" }}>
                                <tr>
                                    <th colSpan={1} align={"left"}> Fecha</th>
                                    <th colSpan={1} align={"center"}> Cédula </th>
                                    <th colSpan={1} align={"center"}> Nombres </th>
                                    <th colSpan={1} align={"center"}> Unidad </th>
                                    <th colSpan={1} align={"center"}> Régimen </th>
                                    <th colSpan={1} align={"center"}> RMU <br /> vigente </th>
                                    <th colSpan={1} align={"center"}> Total Horas <br /> Supl. </th>
                                    <th colSpan={1} align={"center"}> Total Horas <br /> Extraord. </th>
                                    <th colSpan={1} align={"center"}> Total Horas <br /> Extras </th>
                                    <th colSpan={1} align={"center"}> Total Horas <br /> Extras Planif. </th>
                                    <th colSpan={1} align={"center"}> Valor Horas <br /> Supl. </th>
                                    <th colSpan={1} align={"center"}> Valor Horas <br /> Extraord. </th>
                                    <th colSpan={1} align={"center"}> Valor a Recibir </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className='rows_tabla_planificacion_he' style={{ fontSize: "0.7rem" }}>
                                    <td className="centrado"> {ObtenerFechaFromIsoFormat(infoIndividual.fechasolicitud)} </td>
                                    <td className="centrado"> {infoIndividual.identificacion} </td>
                                    <td className="izquierda"> {infoIndividual.nombres} </td>
                                    <td className="centrado"> {infoIndividual.nombreestructuraorganica} </td>
                                    <td className="centrado"> {infoIndividual.regimen} </td>
                                    <td className="centrado"> {infoIndividual.rmu.toFixed(2)} </td>
                                    <td className="centrado"> {infoIndividual.hesuplementarias} </td>
                                    <td className="centrado"> {infoIndividual.heextraordinarias} </td>
                                    <td className="centrado"> {infoIndividual.hetotal} </td>
                                    <td className="centrado"> {infoIndividual.hetotalplanif} </td>
                                    <td className="centrado"> {infoIndividual.vhesuplementarias?.toFixed(2)} </td>
                                    <td className="centrado"> {infoIndividual.vheextraordinarias?.toFixed(2)} </td>
                                    <td className="centrado"> {infoIndividual.tvhorasextras?.toFixed(2)} </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </React.Fragment>
            );
        }
    }, [infoIndividual])

    async function defaultRechazo() {
        setrechazo(false);
        await actualizacionDatos();
    }

    return (
        <React.Fragment>
            {currentRows.length > 0 && (info.roles_usuario.includes(ROL_DIRECTIVO_UNIDAD) || info.roles_usuario.includes(ROL_APROBADOR)) && (
                <Row className="d-flex justify-content-center">
                    <button
                        disabled={loadingAccion == true}
                        className="button-blue2"
                        onClick={() => aceptarTodasSolicitudes(sortedSolicitudes)}>
                        Aprobar Todos
                    </button>
                </Row>
            )}
            <Col md="3">
                <div style={{ marginBottom: -20 }} className="d-flex align-items-center justify-content-start">
                    <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                    <select
                        id="rowsPerPageSelect"
                        value={rowsPerPage}
                        onChange={handleRowsPerPageChange}
                        className="custom-select custom-select-sm mr-2"
                        style={{ width: 'auto' }}
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                    </select>
                    <Label className="mb-0">filas</Label>
                </div>
            </Col>
            <Row className="d-flex justify-content-end">
                <Col md="3">
                    <Input
                        type="text"
                        placeholder="Buscar..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="form-control-sm" // Reduce el tamaño del input
                    />
                </Col>
            </Row>
            {contenidoTablaApp()}
            <Pagination size="sm" className="pagination_planificacion_he">
                {renderPageNumbers}
            </Pagination>
            <ModalCargando
                show={loadingAccion != false}
                onClose={() => setloadingAccion(false)}
                textoCargando='APROBANDO'
                size='md'
            />
            <ModalVistaPreviaDocumentos
                show={urlDocSolicitud !== ""}
                cargandoDatos={loadingAccion}
                size='xl'
                tituloModal='Solicitud de Horas Extras'
                onClose={() => seturlDocSolicitud("")}
                urlArchivo={urlDocSolicitud}
                allHeight={true}
            />
            {infoIndividual !== null &&
                <ModalVistaPreviaDocumento
                    show={urlDocAprobar !== ""}
                    urlArchivo={urlDocAprobar}
                    size="xl"
                    tituloModal=""
                    cargandoDatos={loadingAccion}
                    onClose={() => { seturlDocAprobar("") }}
                    accionOnAccept={true}
                    asyncAccion={() => enviarFirmaDirectivo(infoIndividual)}
                    closeAfterAsync={true}
                    botonCerrar={true}
                    zoomDefaultValue={1.5}
                />
            }
            <ModalRechazo
                show={rechazo !== false}
                size="xl"
                onClose={() => setrechazo(false)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar la solicitud de horas extras?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => rechazarSolicitud(infoIndividual?.idsolicitud, { Observacion: observacion })}
                contentModal={contenidoModalRechazo}
                tituloModal={"Negación de Solicitud de Horas Extras"}
                asyncAfterOnClose={() => defaultRechazo()}
                labelObservacion={"Indique el motivo de negación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}
            />
            {/* <ModalConfirmacion
                idModal="ModalConfirmarAprobacionSolPagohe"

                show={condicion != false}
                size='md'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                // nam
                mensajeConfirmacion=''
                nombreBotonAccion='Aceptar'
                nombreBotonCerrarModal='Cancelar'
                classNameBotonAccion='mr-2 btnEspolPrimary btn btn-primary'
                classNameBotonCerrarModal2='btn-white-red btn btn-secondary'
                onClose={() => { setcondicion(false) }}
                asyncOnClick={() => aceptarTodasSolicitudes(sortedSolicitudes)}
                contentModal={contenidoConfirmacion}
                tituloModal='Solicitudes por Aprobar'
                //classNameContainer="containerModalRevision"
                useContainer={true}
            /> */}
        </React.Fragment>
    )
}

